import { useState, useCallback } from 'react'
import { User, UserRole } from '../data/types'

interface UseAuthReturn {
  user: User | null
  isAuthenticated: boolean
  isAdmin: boolean
  isBrand: boolean
  isGrapevine: boolean
  login: (
    email: string,
    password: string,
    role: UserRole,
    brandName?: string,
    brandId?: string,
  ) => boolean
  logout: () => void
}

export function useAuth(): UseAuthReturn {
  const [user, setUser] = useState<User | null>(null)

  const login = useCallback(
    (
      email: string,
      password: string,
      role: UserRole,
      brandName?: string,
      brandId?: string,
    ): boolean => {
      if (!email || !password) return false

      let name = email.split('@')[0]
      let company = 'Brand Partner'

      if (role === 'admin') {
        name = 'Woolworths Admin'
        company = 'Woolworths SA'
      } else if (role === 'grapevine') {
        name = 'Grapevine Admin'
        company = 'Grapevine Media'
      } else if (role === 'brand' && brandName) {
        name = brandName
        company = brandName
      }

      const newUser: User = {
        id: `user-${Date.now()}`,
        email,
        name,
        role,
        company,
        brandId,
      }

      setUser(newUser)
      return true
    },
    [],
  )

  const logout = useCallback(() => {
    setUser(null)
  }, [])

  return {
    user,
    isAuthenticated: user !== null,
    isAdmin: user?.role === 'admin',
    isBrand: user?.role === 'brand',
    isGrapevine: user?.role === 'grapevine',
    login,
    logout,
  }
}
